<template>
  <div
    class="member"
    :class="[theme && `member--${theme}`]"
    :data-id="data.id"
    @click="$emit('changeSelection', data.id)"
  >
    <div class="member__avatar">
      <div class="member__avatar-image">
        <img :src="data.avatar" :alt="`${data.first_name} ${data.last_name}`" />
      </div>
    </div>

    <div class="member__short-title" v-if="theme === 'mini'">
      {{ data.first_name }}
    </div>

    <div class="member__content" v-else>
      <div class="member__title">{{ data.first_name }} {{ data.last_name }}</div>
      <div class="member__description">
        <div class="member__status" :class="[data.online ? 'online' : 'offline']"></div>
        {{ data.online ? $t('chat.member.online') : $t('chat.member.offline') }}
      </div>
      <div v-if="isSelectable" class="member__checkbox" :class="[selected && 'is-selected']">
        <SvgIcon name="checkbox-arrow" />
      </div>
    </div>
    <div v-if="!noActions && !isSelectable" class="member__actions">
      <svg @click="handlePrivateChatClick" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8" cy="5" r="0.5" fill="#003882" stroke="#003882"/>
        <path d="M8 8V10.6667M4.66667 14H11.3333C12.8061 14 14 12.8061 14 11.3333V4.66667C14 3.19391 12.8061 2 11.3333 2H4.66667C3.19391 2 2 3.19391 2 4.66667V11.3333C2 12.8061 3.19391 14 4.66667 14Z" stroke="#003882" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <router-link :to="`/participants/${data.id}`">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 10.6667C15 11.0498 14.8478 11.4172 14.5769 11.688C14.306 11.9589 13.9386 12.1111 13.5556 12.1111H4.88889L2 15V3.44444C2 3.06135 2.15218 2.69395 2.42307 2.42307C2.69395 2.15218 3.06135 2 3.44444 2H13.5556C13.9386 2 14.306 2.15218 14.5769 2.42307C14.8478 2.69395 15 3.06135 15 3.44444V10.6667Z" stroke="#CCD7E6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import { withUi } from '@/components/ui'

export default {
  mixins: [withUi],
  props: {
    theme: String,
    selected: Boolean,
    noActions: Boolean,
    isSelectable: {
      type: Boolean,
      default: false,
    },
    includePopover: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async handlePrivateChatClick() {
      await this.createGroupP2P(this.data).catch((err) => {
        let text = ''
        try {
          text =
            err.errors &&
            Object.keys(err.errors)
              .map((key) => err.errors[key][0])
              .join(', ')
        } catch (e) {
          //
        }

        this.$toast({ type: 'error', title: err.message, text })
      })

      // this.$emit('changeView', 'members')
    },
    ...mapActions('chat', ['createGroupP2P']),
    ...mapMutations('chat', ['setActiveDialog', 'setReply']),
  },
}
</script>

<style lang="scss" scoped>
.member {
  position: relative;
  z-index: 1;
  display: flex;
  border-radius: 10px;
  padding: 25px;
  margin-bottom: 10px;
  transition: background 0.25s ease;
  cursor: pointer;
  &:hover {
    background: #FFFFFF;
    box-shadow: 0px 12px 21px 0px #B4BBC630;
    z-index: 2;

    .member__actions {
      display: flex;
    }
  }
  &__actions {
    position: absolute;
    top: 26px;
    right: 15px;
    display: none;
    align-items: center;

    > * + * {
      margin-left: 12px;
    }
  }
  &__avatar {
    position: relative;
    flex: 0 0 60px;
    max-width: 60px;
  }
  &__avatar-image {
    position: relative;
    z-index: 1;
    width: 60px;
    height: 60px;
    border-radius: 15px;
    background: #f4f4f4;
    overflow: hidden;
    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: top center;
    }
  }
  &__content {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 0 0 calc(100% - 60px);
    max-width: calc(100% - 60px);
    min-width: 1px;
    padding-left: 15px;
    padding-right: 30px;
  }

  &__title {
    position: relative;
    font-size: 15px;
    font-weight: 700;
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &__description {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: $dark;
  }
  &__status {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    margin-right: 5px;
    &.online {
      background: #1ac57e;
    }
    &.offline {
      background: $dark;
    }
  }
  &__checkbox {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    min-width: 20px;
    min-height: 20px;
    font-size: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    background: $lightGray;
    border-radius: 3px;
    transition: background 0.25s ease-in-out;
    .svg-icon {
      font-size: 7px;
      color: white;
      transform: scale(0);
      transition: transform 0.25s ease-in-out;
      will-change: transform;
      backface-visibility: hidden;
    }
    &.is-selected {
      background: $primary;
      .svg-icon {
        transform: scale(1);
      }
    }
  }
  &__short-title {
    font-size: 12px;
    margin-top: 8px;
    text-align: center;
    color: $dark;
    transition: color 0.25s $ease;
  }

  // more
  &__more {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    ::v-deep .more__menu {
      right: 0;
      top: 100%;
      width: 130px;
    }
  }

  &--simple {
    padding: 15px;
    background: transparent;
    box-shadow: none;
    margin-bottom: 0;
    .member__more {
      right: 30px;
    }
  }
  &--mini {
    display: block;
    padding: 0 6px;
    box-shadow: none;
    margin-bottom: 0;
    &:hover {
      background: transparent;
      .member__short-title {
        color: $primary;
      }
    }
  }
}
</style>
